import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getPropertyId, getPropertyLocation } from 'store/property/propertySelectors';
import { getQuery } from 'store/propertyAvailability/propertyAvailabilitySelectors';
import createSearchQueryString from 'lib/search/createSearchQueryString';
import { FEATURED_PROPERTY_SOURCES } from 'lib/enums/property';

const VALID_SOURCES = Object.keys(FEATURED_PROPERTY_SOURCES);

const FeaturedPropertyRedirector = () => {
  const query = useSelector(getQuery);
  const propertyId = useSelector(getPropertyId);
  const location = useSelector(getPropertyLocation);

  if (VALID_SOURCES.includes(String(query.utm_source).toUpperCase()) && location && propertyId) {
    const searchQuery = { ...query, location, featuredPropertyId: propertyId };
    const searchLocation = { pathname: '/search/list', search: `?${createSearchQueryString(searchQuery)}` };
    return <Redirect to={searchLocation} />;
  } else {
    return null;
  }
};

FeaturedPropertyRedirector.propTypes = {
  query: PropTypes.object,
  propertyId: PropTypes.string,
  location: PropTypes.string,
};

export default FeaturedPropertyRedirector;
